class RebuySmartCart {
  static headerID = 'sections--16365092896834__header'
  static config = {
    timeoutDuration: 5000,
  }

  constructor(config = {}) {
    this.config = {
      ...RebuySmartCart.config,
      ...config,
    }

    this.boundHandlers = {
      update: this.#updateCount.bind(this),
      ready: this.#handleSmartCartReady.bind(this),
      toggle: this.#toggleSmartCart.bind(this),
    }

    this.cartToggle = document.getElementById('cart-toggle')
    this.cartCount = document.getElementById('cart-count')

    this.isSmartCart = window.theme.cart_type === 'rebuy'
    this.hasSmartCart = !!window.Rebuy && !! window.Rebuy?.SmartCart
    this.enableSmartCart = this.isSmartCart && this.hasSmartCart
    this.smartCart = null

    this.timeoutID = null

    this.#mount()
  }

  #mount() {
    if (this.hasSmartCart) {
      this.boundHandlers.ready()
    } else {
      document.addEventListener('rebuy:smartcart.ready', this.boundHandlers.ready)

      this.timeoutID = setTimeout(() => {
        document.removeEventListener('rebuy:smartcart.ready', this.boundHandlers.ready)
        this.cartToggle.classList.remove('pointer-events-none')
      }, this.config.timeoutDuration)
    }
  }

  #toggleSmartCart(event) {
    event.preventDefault()
    event.stopPropagation()

    this.smartCart.visible ? this.smartCart.hide() : this.smartCart.show()
  }

  #updateCount() {
    const currentCount = parseInt(this.cartCount.dataset.cartCount)
    const newCount = this.smartCart.itemCount()

    if (newCount !== currentCount) {
      this.#fetchUpdatedHeader()
    }
  }

  #handleSmartCartReady(event) {
    if (this.timeoutID) {
      clearTimeout(this.timeoutID)
      this.timeoutID = null
    }

    this.smartCart = event.detail.smartcart || window.Rebuy?.SmartCart
    
    if (!this.smartCart) return
    
    this.hasSmartCart = true
    this.enableSmartCart = this.isSmartCart && this.hasSmartCart
    
    if (!this.enableSmartCart) {
      setTimeout(() => {
        this.smartCart.isPreview = true
        this.smartCart.enabled = false
        this.smartCart.visible = false
        this.smartCart.unbindEvents()
        this.smartCart.destroy()
        this.cartToggle.classList.remove('pointer-events-none')
      }, 0)
      
      return
    }
    
    this.cartToggle.classList.remove('pointer-events-none')
    
    const theme = window.theme || {}
    theme.is_smartcart = true

    document.addEventListener('rebuy:cart.change', this.boundHandlers.update)
    this.cartToggle.addEventListener('click', this.boundHandlers.toggle)
  }

  async #fetchUpdatedHeader() {
    try {
      const url = new URL(window.location.href)
      url.searchParams.set('sections', RebuySmartCart.headerID)

      const response = await fetch(url.toString())
      
      if (!response.ok) {
        throw new Error('RebuySmartCart: Error fetching header section (#fetchUpdatedHeader())')
      }

      const json = await response.json()

      this.#updateDOMContent(json[RebuySmartCart.headerID])
    } catch (error) {
      console.error(error)
    }
  }

  #updateDOMContent(content) {
    if (!content) {
      console.error('RebuySmartCart: No content passed. Check header section ID in file. (#updateDOMContent())')
      return
    }

    const parser = new DOMParser()
    const doc = parser.parseFromString(content, 'text/html')
    const newCount = doc.getElementById('cart-count')
    this.cartCount.innerHTML = newCount.innerHTML
  }
}

export default RebuySmartCart